import { Box, Button, Paper, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import { useTranslations } from 'context/TranslationContext';

import { InvoiceVerificationFieldName } from 'utils/constants/invoiceVerificationFieldNames';

import { cardHeaderStyle } from 'styles/shared/CardStyle';

interface ReimbursementDisplayCardProps {
  isEditing: boolean;
  onToggleEdit: () => void;
}

export const ReimbursementDisplayCard = ({
  isEditing,
  onToggleEdit
}: ReimbursementDisplayCardProps) => {
  const { translate } = useTranslations();
  const { watch } = useFormContext();

  const watchedReimbursementName = watch(
    InvoiceVerificationFieldName.ReimbursementCounterpartyName
  );

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: '1rem',
        border: '1px solid #e5e7eb'
      }}
    >
      <Box
        sx={{
          ...cardHeaderStyle,
          justifyContent: 'space-between',
          borderBottomLeftRadius: '16px',
          borderBottomRightRadius: '16px'
        }}
      >
        <Typography
          variant="body1"
          sx={{
            fontSize: '0.75rem',
            fontWeight: 600
          }}
        >
          {watchedReimbursementName || '-'}
        </Typography>
        <Button variant="outlined" size="small" onClick={onToggleEdit}>
          {isEditing
            ? translate('buttons.cancel')
            : translate('buttons.change')}
        </Button>
      </Box>
    </Paper>
  );
};
